<template>
  <section class="buildingsGuidelines">
    <div class="mb-3">Follow these guidelines when editing to ensure formatting is correct:</div>
    <div>
      <ul>
        <li>The "Building Key" is the <strong>unique ID</strong> per building.</li>
        <li>A new "Building Key" value will <strong>create</strong> a new building.</li>
        <li>An existing "Building Key" value will <strong>update</strong> that existing building.</li>
        <li>In the "Floors" value field, be sure to separate floor names in the cell with a <strong>comma listing them from lowest to highest (i.e. "Parking, Lobby, 2, 3, 4, 5")</strong>.</li>
        <li>Because the "Building Key" is used in the spaces file to associate all building attributes to mapped spaces, be sure to <strong>input Building Key values that are easy to remember and make sense</strong> when associating spaces.</li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name: 'buildingsSteps',
}
</script>
<style lang="scss" scoped>
</style>
